import { useMutation, useQueryClient } from '@tanstack/react-query';

import { refreshSession } from '@/shared/api/axios';

import { authKeys } from './query-keys';

/**
 * Someone just granted a role holds it in the next token, not the one they signed in with. So
 * this takes a fresh token first, then reads the session again; if that now carries a
 * permission, the gate above this page lets them through without a sign-out.
 */
export const useRetryAccess = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      // A refused refresh is not the question here: the account lookup below answers it, and a
      // 401 there sends the person to sign in.
      await refreshSession().catch(() => undefined);
      await queryClient.refetchQueries({ queryKey: authKeys.currentUser() });
    },
  });
};
